define('CustomProductCollection.PriceHelper', ['underscore'], function CustomProductCollectionPriceHelper(_) {
    'use strict';

    /**
     * Utility functions for price range extraction/computation
     * in custom product collection modules.
     * Depends on underscore for pluck/sort/min/max.
     * @module CustomProductCollection.PriceHelper
     */

    /**
     * Computes price range from an array of child item data.
     * @param {Array} childrenItemData
     * @returns {Object} min/max and formatted price range.
     */
    function getPriceRangeFromChildren(childrenItemData) {
        var sortedChildrenPricesFormatted;
        var sortedChildrenPrices;

        sortedChildrenPricesFormatted = _(childrenItemData)
            .pluck('onlinecustomerprice_formatted')
            .sort();

        sortedChildrenPrices = _(childrenItemData).pluck('onlinecustomerprice');

        return {
            min: _(sortedChildrenPrices).min(),
            max: _(sortedChildrenPrices).max(),
            minFormatted: sortedChildrenPricesFormatted[0],
            maxFormatted: sortedChildrenPricesFormatted[sortedChildrenPricesFormatted.length - 1]
        };
    }

    /**
     * @returns {Object} Utility API for price range computations
     */
    return {
        getPriceRangeFromChildren: getPriceRangeFromChildren
    };
});
